import { render } from "./News.vue?vue&type=template&id=14646134&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=14646134&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14646134"

export default script